import * as React from "react";
import { Icon, Popup } from "semantic-ui-react";

export default function GreenRedSignal({
                                           greenText = undefined,
                                           redText = undefined
                                       }: { greenText?: string; redText?: string }): JSX.Element {
    return <Popup wide="very"
                  content={greenText !== undefined ? greenText : redText}
                  trigger={
                      <Icon
                          circular={true}
                          color={greenText !== undefined ? "green" : "red"}
                          inverted={true}
                          size="small"/>}
    />
}
